import React from 'react';
import { siteConfig } from '../../data/mock';
import { Phone, MapPin, MessageCircle } from 'lucide-react';

const Footer = () => {
  const whatsappLink = `https://wa.me/${siteConfig.whatsappNumber}?text=${encodeURIComponent(siteConfig.whatsappMessage)}`;

  return (
    <footer className="bg-[#0B1221] border-t border-[#1e293b]">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-3 gap-12">
          {/* Logo and Description */}
          <div className="space-y-6">
            <img
              src="/logo.png"
              alt="Igor Campos Advocacia"
              className="h-16 w-auto"
            />
            <p className="text-neutral-400 text-sm leading-relaxed">
              Advocacia especializada em direito empresarial e renegociação de dívidas bancárias.
            </p>
          </div>

          {/* Contact Info */}
          <div className="space-y-6">
            <h3 className="text-white font-semibold text-lg">Contato</h3>
            <ul className="space-y-4">
              {siteConfig.phones.map((phone, index) => (
                <li key={index} className="flex items-center gap-3 text-neutral-400 hover:text-[#c9a962] transition-colors">
                  <div className="w-8 h-8 border border-[#c9a962]/30 rounded flex items-center justify-center">
                    <Phone className="w-4 h-4 text-[#c9a962]" />
                  </div>
                  <div>
                    <span className="text-xs text-neutral-500 block">{phone.name}</span>
                    <span>{phone.number}</span>
                  </div>
                </li>
              ))}
              <li className="flex items-start gap-3 text-neutral-400">
                <div className="w-8 h-8 border border-[#c9a962]/30 rounded flex items-center justify-center flex-shrink-0">
                  <MapPin className="w-4 h-4 text-[#c9a962]" />
                </div>
                <span className="text-sm">{siteConfig.address}</span>
              </li>
            </ul>
          </div>

          {/* CTA */}
          <div className="space-y-6">
            <h3 className="text-white font-semibold text-lg">Fale Conosco</h3>
            <p className="text-neutral-400 text-sm">
              Pronto para resolver suas dívidas? Entre em contato agora.
            </p>
            <a
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-[#32D74B] hover:bg-[#28b03d] text-white px-6 py-3 rounded-lg font-bold uppercase tracking-wide transition-all duration-300 hover:scale-105 shadow-lg shadow-green-500/20"
            >
              <MessageCircle className="w-4 h-4" />
              WhatsApp
            </a>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-16 pt-8 border-t border-[#1e293b]">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-neutral-500 text-sm">
              © {new Date().getFullYear()} {siteConfig.name}. Todos os direitos reservados.
            </p>
            <p className="text-neutral-600 text-xs">
              Advocacia especializada em Belo Horizonte
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
